import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useErrorContext } from './../../components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';
import { useLocale } from './../../components/special/LanguageProvider';
import { apiGetCall, apiPostCall, isResultOk } from './../../components/special/apiCall';
import  EditForm  from 'components/form/EditForm';
import InputText from './../../components/input/InputText';
import  EditFormFieldTable  from 'components/form/EditFormFieldTable';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const TransactionGroupEdit = ({history}) => {
  
  const params = new URLSearchParams(useLocation().search);  
  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();
  const { t } = useLocale();

   //Init blank formdata record.
   const [formData, setFormData] = useState({        
    isNew : true        
  });  

  //Init blank working data record
  const [workingData, setWorkingData] = useState({
    transactionGroupID: 0,
    groupKey: "",
    name: ""
  });

  const goBack = () => {
    history.push("/admin/transactiongroups");
  }

  const loadFormData = async() => {
    setIsPageLoading(true);
    let newFormData = {...formData};    
    //Read the query parameters, if we don´t have any then go back to transaction keys.
    let isNew = params.get("new");    
    if (!isNew){
      let transactionGroupID = params.get("transactiongroupid");    
      if (transactionGroupID == null || transactionGroupID <= 0){      
        goBack();
      }    
      else{
        newFormData.isNew = false;      
        let requestResult = await apiGetCall(BASE_URL + '/admin/transactionkeygroup/' + transactionGroupID);       
        if (isResultOk(requestResult, setCheckErrorItems)){        
          setWorkingData(requestResult);                
        }  
      }
    }
      
    setFormData(newFormData);
    setIsPageLoading(false);
  }

  useEffect(() => {
    loadFormData();
  }, []);

  const onSaveClick = async() => {
    setIsPageLoading(true);
    let requestResult = null;
    if (formData.isNew){      
      requestResult = await apiPostCall(BASE_URL + '/admin/transactionkeygroup/create', workingData);       
    }
    else{      
      requestResult = await apiPostCall(BASE_URL + '/admin/transactionkeygroup/change', workingData);       
    }    
    if (isResultOk(requestResult, setCheckErrorItems)){          
      goBack();
    }
    setIsPageLoading(false);    
  }

  const onBackClick = () => {    
    goBack();
  }
  
  const validateInput = async () => {
    let messages = [];      
    if (workingData.groupKey === ""){
      messages.push("Vantar númer á færslulykilahóp");      
    }

    let requestResult = await apiGetCall(BASE_URL + '/admin/transactionkeygroup/exists/' + workingData.groupKey);           
    if (isResultOk(requestResult, setCheckErrorItems)){              
      if (requestResult.exists){        
        messages.push("Númer á færslulykilahóp þegar í notkun");  
      }
    }  

    if (workingData.name === ""){
      messages.push("Vantar heiti á færslulykilahóp");
    }
    return messages; 
  }

  
  return (
    <EditForm title={formData.isNew ? "Nýr færslulyklahópur" : "Breyta færslulyklahópi"} onSubmitClick={onSaveClick} onBackClick={onBackClick} onValidate={validateInput}>
      <EditFormFieldTable fields={[
        {
          title: "Númer",
          edit : () => (<InputText name="Key" disabled={!formData.isNew} value={workingData.groupKey} maxLength="6" onChange={(value) => setWorkingData({ ...workingData, groupKey : value})}/>)          
        },
        {
          title: "Heiti",
          edit : () => (<InputText name="name" value={workingData.name} onChange={(value) => setWorkingData({ ...workingData, name : value})}/>)          
        },          
      ]}/>                                                                                
    </EditForm>    
  );
}

